import React, { useMemo } from 'react';
import {
  DescriptionContainer,
  IconAndLabel,
  IconContainer,
  Label,
  OptionContainer,
  Description,
} from './Option.styles';
import { StableCoinOption } from 'pages/open-position/index.page';
import { useBalanceDai, useBalanceUsdc, useBalanceUsdt } from '@components/store/getters';
import { naturalNumber } from '@components/eth/Utils';

export const Option = ({ label, value, icon, config, selected, isDropdownOpen, onClick }: StableCoinOption) => {
  const usdcBalance = useBalanceUsdc();
  const usdtBalance = useBalanceUsdt();
  const daiBalance = useBalanceDai();

  const descriptionContent = useMemo(() => {
    if (!config?.withDescription) return <></>;
    if (config?.type === 'stableCoin') {
      const amount = value === 'usdc' ? usdcBalance : value === 'dai' ? daiBalance : usdtBalance;

      return (
        <DescriptionContainer withPaddingLeft key={amount}>
          <Description type="span">Balance: {amount ? naturalNumber(amount.toString()) : '0'}</Description>
        </DescriptionContainer>
      );
    }

    if (config?.type === 'leverage') {
      return (
        <DescriptionContainer>
          <Description type="span">Leverage</Description>
        </DescriptionContainer>
      );
    }
  }, [usdcBalance, usdtBalance, daiBalance, value, config]);

  return (
    <OptionContainer key={value} selected={selected} isDropdownOpen={isDropdownOpen} onClick={onClick}>
      <IconAndLabel>
        {icon && <IconContainer>{icon}</IconContainer>}
        <Label type="span" key={label}>
          {label}
        </Label>
      </IconAndLabel>
      {descriptionContent}
    </OptionContainer>
  );
};
